import React from 'react';
import { useApiTable } from '../../../hooks/useApiTable';
import { apiMeGetPaymentHistoryPost } from '../../../api/me.getPaymentHistory.[post]';
import { OrderHistoryPaymentListItem } from '../../order/history/payment-list/item/OrderHistoryPaymentListItem';
import { Environment } from '../../../environment';
import { BlockLoader } from '../../../module/global/component/BlockLoader';
import { XSSection } from '../../../xs/component/section/XSSection';
import { XSIcon } from '../../../xs/component/icon/XSIcon';

export function PaymentHistoryList() {
    const getData = useApiTable(
        (params) =>
            apiMeGetPaymentHistoryPost({
                body: { ...params },
            }),
        {
            runOnInit: true,
            mapCellByType: {
                ROW: (payment) => <OrderHistoryPaymentListItem payment={payment} key={payment.id} />,
            },
        },
    );

    const hasData = (getData.query.result?.table?.body?.rows?.length || 0) > 0;

    if (hasData) {
        return getData.table;
    }

    if (getData.query.isLoading) {
        return <BlockLoader />;
    }

    return (
        <XSSection gap={'md'}>
            <XSIcon color={'primary'}>info</XSIcon>

            <a href={`${Environment.V1_PUBLIC_PATH}/customer/order-history`}>
                Can't find your receipt? Try looking in our previous version by clicking here
            </a>
        </XSSection>
    );
}
